<template>
  <v-card>
    <v-card-title class="d-flex flex-wrap align-center">
      <v-btn-toggle v-model="activeTab" mandatory dense class="mr-4">
        <v-btn small>{{ $t('dealer.orders.tabs.all') }} ({{ totalCount }})</v-btn>
        <v-btn small>{{ $t('dealer.orders.tabs.nuovo') }} ({{ stats.Nuovo || 0 }})</v-btn>
        <v-btn small>{{ $t('dealer.orders.tabs.inElaborazione') }} ({{ stats.InElaborazione || 0 }})</v-btn>
        <v-btn small>{{ $t('dealer.orders.tabs.spedito') }} ({{ stats.Spedito || 0 }})</v-btn>
      </v-btn-toggle>

      <v-spacer />

      <v-text-field
        v-model="search"
        prepend-inner-icon="mdi-magnify"
        :placeholder="$t('dealer.orders.search')"
        dense
        hide-details
        outlined
        class="shrink"
        style="max-width: 300px"
      />
    </v-card-title>

    <v-data-table
      :headers="headers"
      :items="filteredOrders"
      :search="search"
      :item-class="rowClass"
      sort-by="orderPlacedAt"
      sort-desc
    >
      <template v-slot:[`item.customer`]="{ item }">
        <div>{{ item.customer.firstName }} {{ item.customer.lastName }}</div>
        <div class="caption grey--text">
          {{ item.shippingAddress.city }}, {{ item.shippingAddress.province }}
        </div>
      </template>

      <template v-slot:[`item.orderPlacedAt`]="{ item }">
        {{ formatDate(item.orderPlacedAt) }}
      </template>

      <template v-slot:[`item.total`]="{ item }">
        {{ formatCurrency(item.total) }}
      </template>

      <template v-slot:[`item.state`]="{ item }">
        <v-chip
          small
          :color="stateColor(item.state)"
          :text-color="item.state === 'Completato' ? 'white' : undefined"
          :style="item.state === 'Completato' ? { backgroundColor: '#6a1b9a' } : {}"
        >
          {{ $t(`dealer.states.${item.state}`) }}
        </v-chip>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <template v-if="item.state === 'Nuovo'">
          <v-btn small color="green" dark class="mr-1" @click="$emit('accept', item.id)">
            {{ $t('dealer.orders.accept') }}
          </v-btn>
          <v-btn small color="red" dark class="mr-1" @click="$emit('reject', item.id)">
            {{ $t('dealer.orders.reject') }}
          </v-btn>
        </template>
        <v-btn
          small
          outlined
          :to="{ name: 'DealerOrderDetail', params: { id: item.id } }"
        >
          {{ $t('dealer.orders.detail') }}
        </v-btn>
      </template>
    </v-data-table>
  </v-card>
</template>

<script>
import { formatCurrency } from '@/store/modules/dealerOrders';

export default {
  name: 'DealerOrdersTable',

  props: {
    orders: {
      type: Array,
      default: () => [],
    },
    stats: {
      type: Object,
      default: () => ({}),
    },
  },

  data: () => ({
    activeTab: 0,
    search: '',
  }),

  computed: {
    headers() {
      return [
        { text: this.$t('dealer.orders.headers.code'), value: 'code' },
        { text: this.$t('dealer.orders.headers.customer'), value: 'customer', sortable: false },
        { text: this.$t('dealer.orders.headers.date'), value: 'orderPlacedAt' },
        { text: this.$t('dealer.orders.headers.total'), value: 'total', align: 'end' },
        { text: this.$t('dealer.orders.headers.state'), value: 'state', sortable: false },
        {
          text: this.$t('dealer.orders.headers.actions'), value: 'actions', sortable: false, align: 'end',
        },
      ];
    },

    totalCount() {
      return this.orders.length;
    },

    filteredOrders() {
      const tabStates = [null, 'Nuovo', 'InElaborazione', 'Spedito'];
      const stateFilter = tabStates[this.activeTab];
      if (!stateFilter) return this.orders;
      return this.orders.filter((o) => o.state === stateFilter);
    },
  },

  methods: {
    formatCurrency,

    formatDate(dateStr) {
      if (!dateStr) return '';
      const d = new Date(dateStr);
      const day = String(d.getDate()).padStart(2, '0');
      const month = String(d.getMonth() + 1).padStart(2, '0');
      const year = d.getFullYear();
      return `${day}/${month}/${year}`;
    },

    stateColor(state) {
      const map = {
        Nuovo: 'primary',
        InElaborazione: 'warning',
        Spedito: 'success',
        Completato: 'purple',
      };
      return map[state] || 'grey';
    },

    rowClass(item) {
      return item.state === 'Nuovo' ? 'nuovo-row' : '';
    },
  },
};
</script>

<style scoped>
.v-data-table >>> .nuovo-row {
  background-color: #e3f2fd;
}
</style>
